import _ from 'underscore';

import {LegacySamplesSource} from 'notebook/sample-propagation/legacy/legacy-add-samples-modal/LegacyAddSamplesModal';

import {SamplesSource} from '../sample-collection/SamplesSourceCollector';

/**
 * This function acts as a bridge. It allows the LEGACY sample source collector to retrieve
 * samples from NEW structured tables, for propagation into LEGACY tables.
 *
 * This is subject to the limitations of the new structured tables. (E.g., no batches.)
 */
export default function convertSamplesSourcesToLegacy(
  sources: Array<SamplesSource>
): Array<LegacySamplesSource> {
  return sources.map((samplesSource) => ({
    name: samplesSource.name,
    icon: samplesSource.icon,
    // eslint-disable-next-line no-restricted-syntax
    sampleDetails: _.flatten(samplesSource.samplesByColumn.map(({samples}) => samples)),
  }));
}
